import TetrisGame from '../components/games/TetrisGame.vue'

// 小游戏注册表：列表页与独立游戏页共用，新增游戏在这里加一项即可。
export const games = [
  { id: 'tetris', name: '俄罗斯方块', description: '经典方块消除游戏，支持 W/A/S/D 键盘操作', icon: 'el-icon-s-grid', component: TetrisGame }
]

export function findGame(id) {
  return games.find(game => game.id === id) || null
}
